import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
const points = ['Devolución del 100%', 'Sin formularios', 'Sin drama', 'Sin explicaciones'];
export function GuaranteeSection() {
  return <section className="w-full bg-ink-900 py-20" aria-labelledby="guarantee-title" data-id="element-106" data-mp="9u3b0av1osa5">
      <div className="mx-auto max-w-3xl px-5" data-id="element-107" data-mp="et67h6wylq6i">
        <div className="flex flex-col items-center gap-5 rounded-3xl border border-gold-500/30 bg-ink-800 px-6 py-10 text-center sm:px-10" data-id="element-108" data-mp="ev0podguj46w">
          <span className="flex h-16 w-16 items-center justify-center rounded-full border border-gold-500/40 bg-gold-500/10" data-id="element-109" data-mp="nu4ablvnvrni">
            <ShieldCheckIcon className="h-8 w-8 text-gold-500" aria-hidden="true" data-id="element-110" data-mp="skkppbj1lnci" />
          </span>
          <h2 id="guarantee-title" className="font-display text-2xl uppercase leading-tight text-cream sm:text-3xl" data-id="element-111" data-mp="xk72jjuyl1ks">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="max-w-xl text-sm leading-relaxed text-cream/70 sm:text-base" data-id="element-112" data-mp="17j6a0z3zmr67">
            Abrís los tomos. Los usás. Seguís el protocolo. Si en 7 días no es exactamente lo que
            esperabas:
          </p>
          <ul className="flex flex-wrap justify-center gap-2" data-id="element-113" data-mp="20rizv1wdvdzd">
            {points.map(p => <li key={p} className="rounded-full border border-cream/12 bg-cream/5 px-3.5 py-1.5 text-xs font-semibold text-cream/80" data-id="element-114" data-mp="1vu10o3864d4k">
                {p}
              </li>)}
          </ul>
          <p className="text-xs uppercase tracking-[0.16em] text-gold-400" data-id="element-115" data-mp="2jitofcemzeo3">
            Tasa de devoluciones: menos del 1%
          </p>
        </div>
      </div>
    </section>;
}